"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (range) {
  if (range[1] && range[0].isAfter(range[1])) {
    range = [range[1], range[0]];
  }

  return range;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/clampRange.js
// module id = 800
// module chunks = 0